import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {FuseAnimate, FuseUtils} from '@fuse';
import {bindActionCreators} from 'redux';
import ReactTable from "react-table";
import dateUtil from "../../../../util/dateUtil";
import moment from "moment";
import CallRecordPlayer from './CallRecordPlayer'

class CallRecord extends Component {

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id]);
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText);
    };

    render() {
        const {calls, searchText} = this.props;

        const data = this.getFilteredArray(calls, searchText);

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    filterable
                    previousText='Previous'
                    nextText='Next'
                    loadingText='Loading...'
                    noDataText="目前沒有任何通話紀錄"
                    pageText='頁'
                    ofText='/共'
                    rowsText='筆'
                    data={data
                        .sort((preMission, currMission) => currMission.id - preMission.id)
                        .map(row => {
                            const {
                                chatRoom: { create_at, end_time },
                                requester,
                                requester: { user_type },
                            } = row

                            const vipIdentity = {
                                national: '🇹🇼 國內',
                                overseas: '🛳 海外',
                                foreigners: '✈️ 外籍',
                            }
                            const requesterRole = requester.role.name +
                                (user_type === 'vip' ? `(${vipIdentity[requester.vip.identity]})` : '')
                            const livingArea = (requester.vip && requester.vip.livingArea && requester.vip.livingArea.name)
                                || (requester.city && requester.city.name)
                                || '（無）'
                            const length = this.getCallPeriod({
                                startTime: create_at,
                                endTime: end_time,
                            })

                            return {
                                ...row,
                                requesterRole,
                                livingArea,
                                length,
                            }
                        })
                    }
                    columns={[
                        {
                            Header: '通話編號',
                            accessor: 'id',
                            filterable: true,
                            className: 'justify-center',
                            width: 80,
                        },
                        {
                            Header: '通話對象',
                            accessor: 'requester.name',
                            filterable: true,
                            width: 80,
                        },
                        {
                            Header: '身分',
                            accessor: 'requesterRole',
                            filterable: true,
                            width: 125,
                        },
                        {
                            Header: '通話對象所在地',
                            accessor: 'livingArea',
                            filterable: true,
                            width: 125,
                        },
                        {
                            Header: '來電時間',
                            accessor: 'chatRoom.create_at',
                            filterable: true,
                            className: 'justify-center',
                            width: 150,
                            Cell: row => !row.value ? '無來電時間' : moment(row.value).format('YYYY-MM-DD HH:mm:ss'),
                        },
                        {
                            Header: '結束時間',
                            accessor: 'chatRoom.end_time',
                            filterable: true,
                            className: 'justify-center',
                            width: 150,
                            Cell: row => !row.value ? '無結束時間' : moment(row.value).format('YYYY-MM-DD HH:mm:ss'),
                        },
                        {
                            Header: '通話長度',
                            accessor: 'length',
                            filterable: false,
                            className: 'justify-center',
                            width: 80,
                        },
                        {
                            Header: '通話錄音',
                            accessor: 'chatRoom.archive_id',
                            filterable: false,
                            sortable: false,
                            width: 300,
                            Cell: row => !row.value ? '（無通話錄音）' : <CallRecordPlayer archiveId={row.value}/>,
                        },
                    ]}
                    defaultPageSize={5}
                />
            </FuseAnimate>
        );
    }

    getCallPeriod({startTime, endTime}) {
        if (!startTime || !endTime) return '不適用';

        const milliseconds = new Date(endTime) - new Date(startTime);

        const timeStr = dateUtil.format({
            milliseconds,
            formatPattern: 'HH:mm:ss',
            timezone: 0
        });

        const day = Math.floor(milliseconds / 1000 / 60 / 60 / 24);

        const dayStr = (day > 0) ? day + '天 ' : '';

        return dayStr + timeStr;
    }
}

const styles = theme => ({
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {},
    tooltip: {
        maxWidth: 100,
    }
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}

function mapStateToProps({global: {searchText}}) {
    return {searchText}
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(CallRecord)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/callRecord/CallRecordList.js